module.exports = __webpack_public_path__ + "static/img/iv-2.a424ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iv/iv-2.png
// module id = 6TVA
// module chunks = 1